<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Yakov Grinshpun was born in the Soviet Union, in a Nazi-controlled Jewish ghetto, at the end of World War II. Brainwashed during the last years of Stalin’s rule, he dedicated his life to the regime. The realities of Soviet life gradually led him to disappointment, disillusionment, and distrust. He got tired of his double life—praising the regime as a teacher while hating the system. Rampant anti-Semitism and worsening living conditions led to the desire for change. When the door to Jewish emigration was open by the pressure from the West, he made a difficult and dangerous decision to leave the country for good. After a first unsuccessful attempt, he emigrated at the age of 45. His adjustment in a country with different culture, mentality, and language was difficult and humiliating. However, Yakov didn’t just rebuild his old life; he created a new life for himself and his family in the new country.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?8366f108